"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const classnames_1 = require("classnames");
const react_i18next_1 = require("react-i18next");
const styles = (theme) => (0, core_1.createStyles)({
    title: {
        color: theme.palette.common.black,
        marginTop: theme.spacing(2)
    },
    message: {
        color: theme.palette.common.black,
        marginTop: theme.spacing(2),
        [theme.breakpoints.up('lg')]: {
            marginBottom: theme.spacing(10)
        },
        [theme.breakpoints.down('lg')]: {
            marginBottom: theme.spacing(2)
        }
    },
    withMargins: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2.5)
    },
    buttons: {
        width: '105px'
    },
    buttonColor: {
        color: theme.palette.common.white,
        backgroundColor: '#0a548b',
        '&:hover': {
            backgroundColor: '#0a548b'
        }
    }
});
const VirtualTourCard = ({ classes, item, isLast, onClose, t }) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        flexFlow: 'column'
    } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { width: '90%' } }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ only: ['xs', 'sm', 'md'] }, { children: (0, jsx_runtime_1.jsx)("img", { "aria-hidden": "true", src: item.image, alt: item.header, className: (0, classnames_1.default)('slick-image') }) })), (0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ only: ['xs', 'lg', 'xl'] }, { children: (0, jsx_runtime_1.jsx)("img", { "aria-hidden": "true", src: item.imageTablet, alt: item.header, className: (0, classnames_1.default)('slick-image') }) })), (0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ only: ['sm', 'md', 'lg', 'xl'] }, { children: (0, jsx_runtime_1.jsx)("img", { "aria-hidden": "true", src: item.imageMobile, alt: item.header, className: (0, classnames_1.default)('slick-image') }) }))] }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    width: '100%',
                    alignItems: 'center'
                } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ align: 'center', variant: "h5", className: (0, classnames_1.default)(classes.title) }, { children: item.header })), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ style: {
                            width: '90%'
                        }, align: 'center', className: (0, classnames_1.default)(classes.message) }, { children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: item.body } }) }))] })), (0, jsx_runtime_1.jsx)("div", { children: isLast && ((0, jsx_runtime_1.jsx)(core_1.DialogActions, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ className: classes.buttonColor, size: 'large', variant: 'contained', onClick: onClose }, { children: t('arcade.tour.play') })) })) })] })) })));
exports.default = (0, core_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(VirtualTourCard));
//# sourceMappingURL=VirtualTourCard.js.map